/* vendors-shim.js (perf fix #7, 2026-08-30).
   Loaded on templates where vendors-media.js (Flickity, Fancybox, Isotope, Masonry, Plyr)
   is excluded. Theme code calls some of these unconditionally (e.g. PXUTheme.video.init
   calls Plyr.setup on every page); these inert stand-ins turn those calls into no-ops
   instead of ReferenceErrors. Each first use logs a console.warn so a wrongly excluded
   page is diagnosable: if a real slider/lightbox/video is missing, add its template or
   markup marker to the load_vendors_media logic in layout/theme.liquid. */
(function () {
  'use strict';
  var warned = {};
  function warn(lib) {
    if (!warned[lib] && window.console && console.warn) {
      warned[lib] = true;
      console.warn('[vendors-shim] ' + lib + ' is not loaded on this template (vendors-media.js excluded by layout/theme.liquid).');
    }
  }

  if (!window.Plyr) {
    var PlyrShim = function () { warn('Plyr'); };
    /* Instances must survive method calls: z__jsVideo does new Plyr(...).on/.play and
       sets autoplay/muted/ratio (adversarial review round 1 finding). */
    var plyrNoop = function () {};
    var plyrPlay = function () { return typeof Promise !== 'undefined' ? Promise.resolve() : undefined; };
    PlyrShim.prototype = {
      on: plyrNoop, off: plyrNoop, once: plyrNoop,
      play: plyrPlay, pause: plyrNoop, stop: plyrNoop, restart: plyrNoop,
      togglePlay: plyrPlay, toggleControls: plyrNoop, destroy: plyrNoop,
      supports: function () { return false; }
    };
    PlyrShim.setup = function () { warn('Plyr'); return []; };
    PlyrShim.supported = function () { return false; };
    window.Plyr = PlyrShim;
  }

  if (!window.Flickity) {
    var FlickityShim = function () { warn('Flickity'); };
    FlickityShim.data = function () { warn('Flickity'); return undefined; };
    window.Flickity = FlickityShim;
  }

  if (!window.imagesLoaded) {
    window.imagesLoaded = function (el, opts, cb) {
      warn('imagesLoaded');
      var fn = typeof opts === 'function' ? opts : cb;
      var api = {
        on: function () { return api; },
        off: function () { return api; },
        once: function () { return api; },
        progress: function () { return api; },
        always: function (f) { if (typeof f === 'function') f(api); return api; },
        done: function () { return api; },
        fail: function () { return api; },
        images: []
      };
      if (typeof fn === 'function') fn(api);
      return api;
    };
  }

  if (window.jQuery) {
    var $ = window.jQuery;
    if (!$.fn.flickity) { $.fn.flickity = function () { warn('Flickity'); return this; }; }
    if (!$.fn.isotope) { $.fn.isotope = function () { warn('Isotope'); return this; }; }
    if (!$.fn.masonry) { $.fn.masonry = function () { warn('Masonry'); return this; }; }
    if (!$.fn.imagesLoaded) {
      $.fn.imagesLoaded = function (opts, cb) { return window.imagesLoaded(this, opts, cb); };
    }
    if (!$.fancybox) {
      $.fancybox = {
        open: function () { warn('Fancybox'); },
        close: function () { warn('Fancybox'); },
        destroy: function () {},
        getInstance: function () { return null; },
        defaults: {}
      };
      $.fn.fancybox = function () { warn('Fancybox'); return this; };
    }
  }
})();
